import React from "react";
import SvgIcon from "../svg-icon";

const InputCheckbox = props => {

    const {checked, label, onChange, badge = null} = props


    const handleChange = e => {
        e.preventDefault()
        onChange(!checked)
    }
    return (
        <div className="form__checkbox" onClick={handleChange}>
            <input checked={checked} disabled type="checkbox" name={label}/>

            <label htmlFor={label}>

                <span className="check-wrapper">
                {
                    checked && <SvgIcon id={'checked'}/>
                }
                </span>
                {label}
            </label>

            {
                badge ? <div className="badge">
                    <span>
                        {badge}
                    </span>
                </div> : null
            }
        </div>

    )
}


export default React.memo(InputCheckbox)
